/** 图纸定位工具（计划 P4-4b）：设置开关与定位面板。占位符与 placement-en.ts 相同。 */
export default {
  settings: {
    title: '图纸定位工具',
    enabled: '提供图纸定位工具',
    hint: '默认关闭。开启后，图纸标准面板会提供一个工具，在浏览器中根据输入的两个点把 DXF 移到真实坐标。检查本身不变。',
    warning:
      '此工具是否可接受，或坐标是否必须仅来自持牌测量师的图纸，尚未确认。定位后的文件不带任何标记，因此日后关闭此工具也无法识别已定位的图纸。',
    noBoundary: '尚未设置管辖边界，因此不会向申请人提供此工具：没有边界，就没有任何检查能确认定位后的图纸落在何处。',
  },
  open: '把我的图纸放到真实坐标',
  hint: '适用于按本地坐标绘制的图纸。在您提交之前，文件只留在此浏览器中。',
  note: '请输入经认证测量图上的坐标。此工具不对坐标作认证，您提交的文件仍会经过完整检查。',
  close: '关闭定位工具',
  fileLabel: 'DXF 文件',
  reading: '正在读取图纸…',
  unitLabel: '图纸使用的单位',
  unitChoose: '选择单位',
  units: { m: '米', mm: '毫米', cm: '厘米', ft: '英尺' },
  crsFirst: '请先选择坐标系。',
  points: { a: '点 A', b: '点 B', check: '校核点' },
  vertexLabel: '图纸中的点',
  vertexChoose: '选择一个点',
  listCut: '仅列出前 {{count}} 个点。',
  verticesCut: '此图纸的点太多，无法全部列出。每个图层只列出其前 {{limit}} 个点。',
  east: '东坐标，{{crs}}',
  north: '北坐标，{{crs}}',
  checkHint: '第三个点，不用于定位图纸。它是必填的，因为仅凭两个点无法判断图纸是否镜像，或点是否互换。',
  drawingTitle: '您的图纸',
  placedTitle: '定位后的图纸，上方为北',
  compute: '计算定位',
  result: '比例：1 个图纸单位 = {{factor}} 米。旋转：{{rotation}} 度。点 A 距其坐标 {{a}} 毫米，点 B {{b}} 毫米。',
  resultCheck: '校核点距其坐标 {{off}} 毫米。',
  resultCrs: '这些坐标属于 {{crs}}。提交此图纸时请声明相同的坐标系。',
  download: '下载定位后的 DXF',
  downloadHint:
    '请在 CAD 软件中打开并使用 Zoom Extents，因为其保存的视图仍指向旧位置。与经认证的图纸核对后，选择它作为您的图纸。图层、图块定义和文字均未改变。',
  file: {
    dwg_file: '这是 DWG 文件。请在 CAD 软件中另存为 DXF，然后在此加载。',
    binary_dxf: '这是二进制 DXF。请在 CAD 软件中另存为 ASCII DXF，然后在此加载。',
    not_dxf: '此文件不是 DXF。',
    truncated: '此 DXF 没有结束标记，可能不完整。请重新保存并加载。',
    malformed: '此 DXF 在第 {{line}} 行无法读取。',
    no_entities: '此 DXF 没有图形实体。',
    too_large: '此文件超过 {{limit}} MB，即此处允许的最大上传大小。',
    output_too_large: '定位后的文件将为 {{size}} MB，超过 {{limit}} MB 的上传上限。请删除图纸不需要的内容后重试。',
  },
  refusedTitle: '由于图纸包含以下内容，此工具无法移动它：',
  refusedRow: '图层 {{layer}} 上的 {{type}}：{{count}}（{{reason}}）',
  refusedFix: '请在 CAD 软件中删除或分解（explode）这些内容，另存为 DXF 后重新加载。',
  reason: {
    not_allowed: '此工具不移动的类型',
    extrusion: '镜像绘制或位于其他平面',
    embedded_object: '包含嵌入对象',
    xdata_coordinates: '其扩展数据中带有坐标',
    polyline_mesh: '网格',
    polyline_curve_fit: '曲线拟合的多段线',
    spline_fit_points: '由拟合点绘制的样条曲线',
    hatch_spline_edge: '带样条边的填充',
    hatch_gradient: '渐变填充',
    xref_insert: '外部参照',
    undefined_block: '引用了文件未定义的图块',
    mtext_direction: '已旋转但无方向的多行文字',
    drawing_object: '会失效的裁剪或已存位置',
  },
  fit: {
    scale_mismatch:
      '按所选单位，两个图纸点相距 {{drawing}} 米，但输入的坐标相距 {{typed}} 米：相差超过 0.1 %。请检查单位和点。',
    degenerate_drawing: '点 A 和点 B 是同一个点。请选择两个不同的点。',
    degenerate_typed: '为 A 和 B 输入的坐标相同。',
    bad_number: '请将每个坐标输入为以米为单位的普通数字，如 412345.678，不要使用千位分隔符。',
    out_of_range: '输入的坐标对此处提供的任何坐标系都过大。请检查。',
    baseline_too_short: '点 A 和点 B 太近：至少需要相距 {{min}} 米，否则很小的输入误差会使远角偏移数米。',
    check_point_missing: '必须提供校核点：请在图纸中选择该点，并输入它的两个坐标。',
    mirrored:
      '校核点不符：图纸相对于输入的坐标似乎是镜像的，或点或坐标互换了。请检查。如果图纸是镜像的，请在 CAD 软件中镜像回来。',
    check_point_off: '校核点距输入的坐标 {{off}} 米。请检查点和坐标。',
    check_point_collinear: '校核点几乎在穿过 A 和 B 的直线上，因此无法证明任何事。请选择离该直线更远的点。',
  },
  preview: {
    open: '在地图上预览',
    warning: '点击只是近似值，绝不会用于下载的文件，下载的文件只采用输入的坐标。',
    needPoints: '请先在图纸中选择点 A 和点 B。',
    clickA: '点击点 A 所在的位置。',
    clickB: '点击点 B 所在的位置。',
    placed: '图纸大致的落点。',
    clear: '清除点击',
    map: '定位的地图预览',
  },
}
